"use client";

import { createContext, useContext, type CSSProperties } from "react";

/** Preserve a named header's palette in menu portals outside its DOM subtree. */
export const HeaderDesignContext = createContext<CSSProperties | undefined>(
  undefined,
);
export const useHeaderDesign = () => useContext(HeaderDesignContext);
